import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    '& svg': {
      color: '#BE1224',
      width: '40px',
      height: '40px',
      marginBottom: '20px'
    },
    '& ul': {
      marginTop: '12px',
      marginBottom: '12px',
      fontWeight: 'bold'
    },
    width: '722px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'left'
  }
}));
